import React, { useEffect, useRef, useState } from "react";
import { classes } from "../../../core/data/json/classes";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import {
  activeList,
  classSylabus,
} from "../../../core/common/selectoption/selectoption";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import { TableData } from "../../../core/data/interface";
import { Link, useNavigate } from "react-router-dom";
import TooltipOption from "../../../core/common/tooltipOption";
import { all_routes } from "../../router/all_routes";
import { _get, _post } from "../../Utils/Helper";
import { SingleValue } from "react-select";
import moment from "moment";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
const classSection = [
  { value: "Select", label: "Select" },
  { value: "PRE-NURSERY", label: "PPRE-NURSERYRE" },
  { value: "NURSERY", label: "NURSERY" },
  { value: "PRIMARY", label: "PRIMARY" },
  { value: "SECONDARY", label: "SECONDARY" },
];
const Classes = () => {
  const _form = {
    query_type: "create",
    section: "",
    class_name: "",
    school_name: "",
    capacity: "",
    school_location: "",
  };
  const { school, classes } = useSelector((state: RootState) => state.auth);

  interface Classroom {
    block_no: string;
    capacity: number;
  }

  const [form, setForm] = useState(_form);
  const [new_data_teacher, setNewDataTeacher] = useState([]);
  const [newDataClassRooms, setNewDataClassRooms] = useState<Classroom[]>([]);
  const handleChange = (e: any) => {
    // if (e.target.name === "class_name") {
    //   setForm((p) => ({
    //     ...p,
    //     class_code: `${moment().format("YYYY")}-${form.class_name}`,
    //   }));
    // }
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  };
  // setForm((p) => ({
  //   ...p,
  //   class_code: `${moment().format("YYYY")}-${form.class_name}`,
  // }));

  const handleSubmit = () => {
    if (!form.section) { 
      return toast.error("Please enter a class name")
    }
    const payload = {
      ...form, school_name: school.school_name,school_id: school.school_id,class_code: `${moment().format("YYYY")}-${form.class_name}`
    }
    _post(
      "classes?query_type=create",
      payload,
      (res) => {
        toast.success("Submitted Success");
        setForm((p)=>({...p, class_name:''}))
        getClassRooms();
        // setTimeout(() => {
        //   getTeaherPersonal();
        // }, 1000);
      },
      (err) => {
        // setLoading(false);
        console.log(err);
      }
    );
    // setErrors({});
  };
  const getClassRooms = () => {
    _get(
      `classes?query_type=select-all&school_id=${school.school_id}`,
      (res) => {
        //   navigate(`/agent`)
        console.log(res);
        setNewDataClassRooms(res.data);
      },
      (err) => {
        // setLoading(false)
        console.log(err);
      }
    );
    // console.log(form)
  };
  const navigate = useNavigate();
  const [new_data, setNewData] = useState([]);
  const [new_data_teacher_name, setNewDataTeacherName] = useState({});
  // const getTeaherPersonal = () => {
  //   _get(
  //     "classes?query_type=select-all",
  //     (res) => {
  //       //   navigate(`/agent`)
  //       console.log(res);
  //       setNewData(res.data);
  //     },
  //     (err) => {
  //       // setLoading(false)
  //       console.log(err);
  //     }
  //   );
  //   // console.log(form)
  // };

  const getCapacity = (block_no: string): number | undefined => {
    return newDataClassRooms.find((x) => x.block_no === block_no)?.capacity;
  };
  const { sections } = useSelector((state: RootState) => state.auth);
  // const [sections, setSections] = useState([]);
  const mapped_section = sections?.map((i: any) => ({
    label: i.section_name,
    value: i.section_name,
  }));
  const getTeaherName = () => {
    _get(
      `teachers?query_type=select_teacher_name`,
      (res) => {
        //   navigate(`/agent`)
        console.log(res);
        setNewDataTeacher(res.results);
      },
      (err) => {
        // setLoading(false)
        console.log(err);
      }
    );
    // console.log(form)
  };
  const classOptions = new_data_teacher?.map((i: any) => ({
    label: i.name,
    value: i.name,
  }));

  const classOptions1 = newDataClassRooms?.map((i: any) => ({
    label: i.block_no,
    value: i.block_no,
  }));
  useEffect(() => {
    getTeaherName();
    getClassRooms();
    // getTeaherPersonal();
    // getSections();
  }, [school]);

  const routes = all_routes;

  const data = classes;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };
  const route = all_routes;
  const columns = [
    {
      title: "S/N",
      dataIndex: "1",
      render: (text: string, record: any, index: number) => (
        <>
          <p>
            {index+1}
          </p>
        </>
      ),
    },
    {
      title: "Section",
      dataIndex: "section",
    },
    {
      title: "Class Name",
      dataIndex: "class_name",
    },
  ];
  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              <div className="mb-2">
                <Link
                  to="#"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#add_class"
                >
                  <i className="ti ti-square-rounded-plus-filled me-2" />
                  Add Class
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Classes List</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start mb-3 me-2 position-relative">
                  {/* <PredefinedDateRanges /> */}
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Guardians List */}
              {/* {JSON.stringify(classes)} */}
              <Table columns={columns} dataSource={newDataClassRooms} Selection={false} />
              {/* /Guardians List */}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      {/* /Page Wrapper */}
      <>
        {/* Add Classes */}

        <div className="modal fade" id="add_class">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Class</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>

              <form>
                {/* {JSON.stringify(form)} */}
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                    <div className="mb-3">
                        <label className="form-label">Section</label>
                        <CommonSelect
                          className="select"
                          options={mapped_section}
                          // defaultValue={ {label: "select", value: "select"} }
                          handleChange={(newValue: SingleValue<Option>) =>
                            setForm((prev) => ({
                              ...prev,
                              section: newValue ? newValue.value : "",
                            }))
                          }
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Class Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="class_name"
                          value={form.class_name}
                          onChange={handleChange}
                        />
                      </div>
                      {/* <div className="mb-3">
                        <label className="form-label">School Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="school_name"
                          value={form.school_name}
                          onChange={handleChange}
                        />
                      </div> */}
                      {/* <div className="mb-3">
                        <label className="form-label">School Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="School_name"
                          // disabled={true}
                          value={form.School_name } // Use form.capacity directly, which is set in handleChange
                          onChange={handleChange} // Update form.capacity on change
                        />
                      </div> */}
                      {/* {JSON.stringify(new_data)} */}
                      
                    
                      {/* <div className="mb-3">
                        <label className="form-label">No of Students</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter no of Students"
                          defaultValue={30}
                          name="capacity"
                          value={form.capacity}
                          onChange={handleChange} // Update form.capacity on change
                        />
                      </div> */}
                      {/* <div className="col-xxl col-xl-3 col-md-6"> */}

                      {/* </div> */}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    className="btn btn-primary   me-2"
                    to="#"
                    onClick={() => handleSubmit()}
                  >
                    Add Class
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Add Classes */}
        {/* Edit Classes */}
        <div className="modal fade" id="edit_class">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Class</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Class Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Class Name"
                          defaultValue="I"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Section</label>
                        <CommonSelect
                          className="select"
                          options={classSection}
                          defaultValue={classSection[0]}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">No of Students</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter no of Students"
                          defaultValue={30}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">No of Subjects</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter no of Subjects"
                          // defaultValue={03}
                        />
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="status-title">
                          <h5>Status</h5>
                          <p>Change the Status by toggle </p>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch-sm2"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                  >
                    Save Changes
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Edit Classes */}
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      className="btn btn-danger"
                      data-bs-dismiss="modal"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
        {/* View Classes */}
        <div className="modal fade" id="view_class">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div className="d-flex align-items-center">
                  <h4 className="modal-title">Class Details</h4>
                  <span className="badge badge-soft-success ms-2">
                    <i className="ti ti-circle-filled me-1 fs-5" />
                    Active
                  </span>
                </div>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>Class Name</p>
                        <span>III</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>Section</p>
                        <span>A</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>No of Subjects</p>
                        <span>05</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="class-detail-info">
                        <p>No of Students</p>
                        <span>25</span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /View Classes */}
      </>
    </div>
  );
};

export default Classes;
